export class LFDynamicWidgetConfig {
    public name: string;
    public id: string;
    public widgetType: string;
    public isOpen: boolean = false;
    public activeIndex: number;
    public columnGroup: string;
    public propertyList: any;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/models/lf-dynamic-widget-config.ts